<template>
  <div class="w-100 mt-5">
<!--    <div class="d-flex flex-sm-column-reverse flex-md-column-reverse flex-lg-row custom-route-wrapper justify-content-between">-->
    <div class="row">
      <div class="col-lg-7 col-xxl-5">
        <CustomRouteFormTemplateComponent
            :total-distance="store.state.orderTrueDriver.totalDistance"
            :total-duration="store.state.orderTrueDriver.totalDuration"
            :price="store.state.orderTrueDriver.price"
            :message="message"
            :backendValidationErrors="backendValidationErrors"
            :loading="loading"
            :isOrderable="isOrderable"

            @submit="onSubmit($event)"
        ></CustomRouteFormTemplateComponent>
      </div>
      <div class="col-lg-5 col-xxl-7">
        <CustomRouteMapTemplateComponent></CustomRouteMapTemplateComponent>
      </div>
    </div>

    <ModalComponent :show-title="false" :id-data="'selectVehicleModal'">
      <template #body-content>
        <div class="modal-body">
          <VehicleSelectWrapperComponent :is-main-modal="false" :filtered-vehicles="vehiclesData"></VehicleSelectWrapperComponent>
        </div>
      </template>
    </ModalComponent>

  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {mapState, useStore} from "vuex";
import {routesConst} from "../../routes";
import axios from "axios";
import {axiosHelpers} from "../../helpers/axiosHelpers";
import NameOfHelper from "../../helpers/nameOfHelper";
import {dateHelpers} from "../../helpers/dateHelpers";
// @ts-ignore
import CustomRouteMapTemplateComponent from "../customRouteMapTemplate/CustomRouteMapTemplateComponent.vue";
// @ts-ignore
import CustomRouteFormTemplateComponent from "../customRouteFormTemplate/CustomRouteFormTemplateComponent.vue";
// @ts-ignore
import VehicleSelectWrapperComponent from "../../components/vehicleSelectWrapper/VehicleSelectWrapperComponent.vue";
// @ts-ignore
import ModalComponent from "../../components/modal/ModalComponent.vue";
// @ts-ignore
import apiGoogleService from "../../services/apiGoogleService";
// @ts-ignore
import mapStyle from "../customRouteMapTemplate/mapStyle.json";
// @ts-ignore
import destinationIcon from '/assets/images/destination-icon-last-1.svg';
// @ts-ignore
import originIcon from "/assets/images/start-icon-last-1.svg";
// @ts-ignore
import waypointIcon from "/assets/images/waypoint-icon.svg";
//@ts-ignore
import apiService from "../../services/apiService";

import type {Coords} from "@/store/states/ICoordinatesState.interface";
import type {ApiGoogleResponse, Coordinates} from "@/store/states/ICoordinatesState.interface";
import type {IOrderTrueDriverDateFrequencyState} from "@/store/states/IOrderTrueDriverDateFrequencyState.interface";
import type {IOrderTrueDriverState} from "@/store/states/IOrderTrueDriverState.interface";
import type {IApiResponseVehicle} from "@/interfaces/apiResponseInterfaces/IApiResponseVehicle.interface";
import type {IVehicleState} from "@/store/states/IVehicleState.interface";

import {CustomRouteFormTemplateComponentErrorMessages} from '../../interfaces/enums/CustomRouteFormTemplateComponentErrorMessages.enum';
import {ServiceTypes} from "../../interfaces/enums/ServiceTypes.enum";

export default defineComponent({
  name: 'CustomRouteWrapperComponent',
  components: {
    ModalComponent,
    VehicleSelectWrapperComponent,
    CustomRouteFormTemplateComponent,
    CustomRouteMapTemplateComponent,
  },
  props: {},

  data() {
    return {
      isFirstLoad: true,
      center: <Coords>{},
      map: <object | null>null,
      icons: {
        origin: originIcon,
        destination: destinationIcon,
        waypoint: waypointIcon
      },
      message: {state: false, msg: ''},
      loading: false,
      // oldCoords: [],
      // arrivalTimeStampsUTCs: <Number[]>[],
      // backEndErrorMessage: <string|null>null
      backendValidationErrors: <string[]|null>[],
      isOrderable: false,
      vehiclesData: <IApiResponseVehicle[]>[],
    }
  },

  setup() {
    const store = useStore();

    return {
      store
    }
  },

  computed: {
    ...mapState<IOrderTrueDriverDateFrequencyState>(['orderTrueDriverDates']),
    ...mapState<IOrderTrueDriverState>('orderTrueDriver', {
      passengerCount: (state: IOrderTrueDriverState) => state.passengerCount,
      customRoutesFirst: (state: IOrderTrueDriverState) => state.customRoutes[0].arrivalTime,
      customRouteIdsSequence : (state: IOrderTrueDriverState) => state.customRoutes.map((route) => {
        return route?.routePoint?.place_id ? route?.routePoint?.place_id : route.id;
      }),
      customRouteHasNull: (state: IOrderTrueDriverState) => state.customRoutes.some(item => item.routePoint === null),
      orderTrueDriverStateSelectedTravelObjective: (state: IOrderTrueDriverState) => state.selectedTravelObjective,
    }),
    ...mapState<IVehicleState>('vehicle', {
      selectedVehicle: (state: IVehicleState) => state.selectedVehicle
    }),
  },

  watch: {
    orderTrueDriverDates: {
      handler(newVal, oldVal) {
        this.resetCounters(false, false, false);
      },
      deep: true,
    },
    passengerCount(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.resetCounters(true, false, false);
        const customRoutes = this.store.state.orderTrueDriver.customRoutes.filter(route => route.routePoint !== null);
        if (customRoutes.length >= 2) {
          this.getVehicles();
        }
      }
    },
    customRoutesFirst(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.resetCounters();
        this.getCustomRouteResponse();
      }
    },
    customRouteIdsSequence(newVal, oldVal) {
      if (! Array.isArray(newVal)) {
        return;
      }
      newVal = newVal.filter((val) => typeof val !== 'number');
      oldVal = oldVal.filter((val) => typeof val !== 'number');

      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.resetCounters();
        this.getCustomRouteResponse();
      }
    },
    customRouteHasNull(newVal, oldVal) {
        this.resetCounters();
        if (!newVal) {
          this.getCustomRouteResponse();
        } else {
          this.store.state.orderTrueDriver.customRoutes.forEach(el => {
            if (el.routePoint === null) {
              this.store.commit('orderTrueDriver/UPDATE_ARRIVAL_TIMES_CUSTOM_ROUTES', {id: el.id, value: null});
            }
          })
        }
    },
    orderTrueDriverStateSelectedTravelObjective(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.resetCounters(false, false, false);
      }
    },
    selectedVehicle(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.resetCounters(false, false, false);
      }
    }
  },

  methods: {
    resetCounters(
        resetVehicle: boolean = true,
        resetDistance: boolean = true,
        resetDuration: boolean = true,
    ): void {
      this.isOrderable = false;

      const nameOf = (c) => NameOfHelper.obj(c);
      let stateName = nameOf(() => this.store.state.orderTrueDriver);
      let state: IOrderTrueDriverState = this.store.state[stateName];

      let payload = <any[]>[
          { prop: nameOf(() => state.price), value: 0 }
      ];

      if (resetDistance) {
          payload.push({ prop: nameOf(() => state.totalDistance), value: 0 });
      }

      if (resetDuration) {
          payload.push({ prop: nameOf(() => state.totalDuration), value: { hours: 0, minutes: 0 }});
      }

      this.store.dispatch(stateName + '/updateState', payload);

      if (resetVehicle) {
        this.store.commit('vehicle/SET_STATE_PROP_VALUE', [
          {prop: 'selectedVehicle', value: null},
          {prop: 'selectedId', value: 0}]);
      }
    },

    async getVehicles() {
      if (this.loading) {
        return;
      }
      this.loading = true;

      let passengers = 0;
      let pickup = <string|null>null;
      let dropOff = <string|null>null;

      let state = this.store.state.orderTrueDriver;
      let customDateState = this.store.state.orderTrueDriverDates;
      let customTimeState = this.store.state.orderTrueDriver

      passengers = state.passengerCount;
      pickup = dateHelpers.dateToDisplay(customDateState.selectedStartDate) + ' ' + customTimeState.customRoutes[0].arrivalTime;
      dropOff = dateHelpers.dateToDisplay(customDateState.selectedEndDate) + ' ' + customTimeState.customRoutes[customTimeState.customRoutes.length - 1].arrivalTime;

      await axios.get(apiService.vehicleEndpoint() + '?passengers=' + passengers + '&pickup=' + pickup + '&drop_off=' + dropOff)
          .then((response) => {
              this.vehiclesData = <IApiResponseVehicle[]>response.data.data;
          })
          .finally(() => {
              this.loading = false;
          });
    },

    async getCustomRouteResponse() {

      this.backendValidationErrors = [];

      let customRoutes = this.store.state.orderTrueDriver.customRoutes;
      const totalRoutes = customRoutes.length;

      // Remove empty
      if (totalRoutes > 2) {
        this.store.state.orderTrueDriver.customRoutes = this.store.state.orderTrueDriver.customRoutes.filter((route) => !!route.routePoint);
      }

      if (customRoutes.filter(route => !!route.routePoint).length !== totalRoutes && totalRoutes <= 2) {
        // this.message = { state: true, msg: CustomRouteFormTemplateComponentErrorMessages.MESSAGE_DONT_LEAVE_EMPTY_INPUTS };
        return;
      }

      this.message = { state: false, msg: '' };
      this.loading = true;

      const map = apiGoogleService.initMap(this.center);

      // TO BACKEND REQUEST
      await axios.post<{
        coords: Coordinates,
        googleResponse: ApiGoogleResponse,
        distance: number,
        duration: {
          totalInSec: number,
          hours: number,
          minutes: number
        },
        waypointsArrivalTimes: {routeId: number, dateTime: string}[]
      }>(apiService.googleApiDirectionsGetCustomDirectionEndpoint(), {
        serviceType: ServiceTypes.SERVICE_RENT,
        withDriver: true,
        mainFormData: {...this.store.state.orderTrueDriver},
      }).then((response): void => {
        const data = response.data;

        let result = apiGoogleService.deserializeRoute(data.googleResponse);

        const directionsRenderer = apiGoogleService.directionsRenderer();
        directionsRenderer.setMap(map);
        directionsRenderer.setDirections(result);

        this.store.dispatch('orderTrueDriver/updateState', [
          { prop: 'totalDistance', value: data.distance },
          { prop: 'totalDuration', value: {
              hours: data.duration.hours,
              minutes: data.duration.minutes
            }
          },
        ]);

        data.waypointsArrivalTimes.forEach((item: {routeId: number, dateTime: string}) => {
          this.store.commit('orderTrueDriver/UPDATE_ARRIVAL_TIMES_CUSTOM_ROUTES', {
            id: item.routeId,
            arrivalTime: item.dateTime.split(" ")[1],
            arrivalDate: item.dateTime.split(" ")[0]
          })
        })

        apiGoogleService.displayMarkers(
            map,
            data.coords,
            this.icons,
            this.store.state.orderTrueDriver.customRoutes.filter(route => !!route.routePoint)
        );
      })
          .catch(error => {
            this.backendValidationErrors = axiosHelpers.handleAxiosErrors(error, 'key_unprocessable_content');
          })
          .finally(() => this.loading = false);

      await this.getVehicles();
    },

    calculateWholePriceWithSelectedVehicle: function(): void {

      this.backendValidationErrors = [];

      if (this.isOrderable) {
        this.$router.push(routesConst.ORDER);
        return;
      }

      // Remove empty
      this.store.state.orderTrueDriver.customRoutes = this.store.state.orderTrueDriver.customRoutes.filter((route) => !!route.routePoint);

      let customRoutes = this.store.state.orderTrueDriver.customRoutes;

      const totalRoutes = customRoutes.length;

      if (customRoutes.filter(route => !!route.routePoint).length !== totalRoutes && totalRoutes <= 2) {
        this.message = { state: true, msg: CustomRouteFormTemplateComponentErrorMessages.MESSAGE_DONT_LEAVE_EMPTY_INPUTS };
        return;
      }

      this.message = { state: false, msg: '' };
      this.loading = true;

      const map = apiGoogleService.initMap(this.center);

      // TO BACKEND REQUEST
      axios.post<{
        coords: Coordinates,
        googleResponse: ApiGoogleResponse,
        distance: number,
        duration: {
          totalInSec: number,
          hours: number,
          minutes: number
        },
        price: {
          total: number,
          tax_total: number,
          total_tax_percent: number,
          total_tax_charge_rs: number,
          total_currency: number,
        },
        waypointsArrivalTimes: {routeId: number, dateTime: string}[]
      }>(apiService.pageChooseCustomRoutePageEndpoint(), {
        serviceType: ServiceTypes.SERVICE_RENT,
        withDriver: true,
        vehicleId: this.store.state.vehicle.selectedVehicle.id,
        mainFormData: {...this.store.state.orderTrueDriver},
        dateFormData: {...this.store.state.orderTrueDriverDates}
      }).then((response): void => {
        const data = response.data;

        let result = apiGoogleService.deserializeRoute(data.googleResponse);

        const directionsRenderer = apiGoogleService.directionsRenderer();
        directionsRenderer.setMap(map);
        directionsRenderer.setDirections(result);

        this.store.dispatch('orderTrueDriver/updateState', [
            { prop: 'totalDistance', value: data.distance },
            { prop: 'totalDuration', value: {
                hours: data.duration.hours,
                minutes: data.duration.minutes
              }
            },
          { prop: 'price', value: parseFloat((data.price.tax_total).toFixed(2)) }
        ]);

        data.waypointsArrivalTimes.forEach((item: {routeId: number, dateTime: string}) => {
          this.store.commit('orderTrueDriver/UPDATE_ARRIVAL_TIMES_CUSTOM_ROUTES', {
            id: item.routeId,
            arrivalTime: item.dateTime.split(" ")[1],
            arrivalDate: item.dateTime.split(" ")[0]
          })
        })

        apiGoogleService.displayMarkers(
            map,
            data.coords,
            this.icons,
            this.store.state.orderTrueDriver.customRoutes.filter(route => !!route.routePoint)
        );

        this.isOrderable = true;

      })
      .catch(error => {
        this.backendValidationErrors = axiosHelpers.handleAxiosErrors(error, 'key_unprocessable_content');
      })
      .finally(() => this.loading = false);
    },

    onSubmit: function($event): void {

      const isVehicleSelected = this.store.state.vehicle.selectedVehicle !== null;

      if (isVehicleSelected) {
        this.calculateWholePriceWithSelectedVehicle();
      }

    },
  },

  mounted() {

    this.center = apiGoogleService.COUNTRY_CENTER_COORDINATES_LT;
    this.map = apiGoogleService.initMap(this.center);

    // Reset on page load
    this.store.dispatch('orderTrueDriver/updateState', [
      { prop: 'totalDistance', value: 0 },
      { prop: 'totalDuration', value: { hours: 0, minutes: 0 }},
      { prop: 'price', value: 0 }
    ]);

    setTimeout(() => {
      if (this.store.state.orderTrueDriver.customRoutes.length > 0) {
        this.getCustomRouteResponse();
      }
    }, 1000);
  },
})
</script>

<style lang="scss">
@import '../../../sass/variables';

.custom-route-wrapper {
  padding-top: 2rem;
}

.map-marker-label-style {
  background-color: $black;
  border-radius: 7px;
  font-weight: 500;
  line-height: 1rem;
  font-size: 0.75rem;
  padding: 0.5rem;
  display: flex;
  align-content: center;
}
</style>